import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { onMounted, ref, watch } from 'vue';
import { LottieAnimation } from 'lottie-web-vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  animationData: {
    type: Object,
    default: () => {},
  },
  loop: {
    type: Boolean,
    default: true,
  },
  autoPlay: {
    type: Boolean,
    default: true,
  },
  speed: {
    type: Number,
    default: 1,
  },
},
  emits: ['complete', 'hiddenLoading'],
  setup(__props, { emit: __emit }) {

const animationDataRef = ref({});
const isShowLottieAnimationRef = ref(false);

const props = __props;

const anim = ref();
const emit = __emit;
const onComplete = () => {
  if (!props.loop) {
    emit('complete');
  }
};

watch(
  () => props.animationData,
  newVal => {
    if (newVal && Object.keys(newVal).length > 0) {
      animationDataRef.value = newVal;
      isShowLottieAnimationRef.value = false;
      setTimeout(() => {
        isShowLottieAnimationRef.value = true;
        if (anim.value) {
          anim.value?.stop();
          anim.value?.play();
          emit('hiddenLoading');
        }
      }, 0);
    }
  },
  { immediate: true, deep: true },
);

onMounted(() => {
  animationDataRef.value = props.animationData;
});

return (_ctx: any,_cache: any) => {
  return (isShowLottieAnimationRef.value)
    ? (_openBlock(), _createBlock(_unref(LottieAnimation), {
        key: 0,
        ref_key: "anim",
        ref: anim,
        "animation-data": animationDataRef.value,
        loop: props.loop,
        "auto-play": true,
        speed: 1,
        onComplete: onComplete
      }, null, 8, ["animation-data", "loop"]))
    : _createCommentVNode("", true)
}
}

})